import * as React from 'react';
import { ContentMetricsIcon } from '../Icon/icon';
import './contentMetricsForm.scss';
import { CancelX } from '../Icon/icon';
import { formatDate, getSchema, parseDate } from '../../utils';
import { parseField } from '../../utils';
import { DataType } from '../../enums/DataType';
import TooltipPopover from '../Popover/popover';
import { useSelector } from '../../utils/useSelector';
import { NodeType } from '../../enums/NodeType';
import { Field } from '../MetadataForm/metadataFormField';
import { SchemaField } from '../../types/Metadata';
import { FormUpdater } from '../../types/Field';
export interface ContentMetricsFormProps {
  showHideContentMetricsWidget?: () => any;
  shouldShowMetrics?: boolean;
  updater: FormUpdater;
}
export const ContentMetricsForm = ({
  showHideContentMetricsWidget,
  shouldShowMetrics,
  updater
}: ContentMetricsFormProps) => {
  return (
    <div className="content-metrics-container">
      <a
        onClick={e => {
          showHideContentMetricsWidget();
        }}
        className={`content-metrics-icon ${shouldShowMetrics ? 'active' : ''}`}
      >
        <ContentMetricsIcon />
      </a>
      {shouldShowMetrics && (
        <div className="content-metrics-form">
          <div className="header-row">
            <div className="header">Content Metrics</div>
            <a
              onClick={showHideContentMetricsWidget}
              className="close-content-metrics"
            >
              <CancelX />
            </a>
          </div>
          <div className="scrollable">
            <DPVSection />
            <COESection updater={updater} />
          </div>
        </div>
      )}
    </div>
  );
};

const DPVSection = () => {
  const data = useSelector(s => s.form?.data);
  const schemas = useSelector(s => s?.planning?.selectedWorkspace?.schemas);
  let metricsOrder = [
    ['Item.dpv30', 'Item.nsDpv30'],
    ['Item.dpv90', 'Item.nsDpv90'],
    ['Item.dpvLast12Months', 'Item.nsDpvLast12Months'],
    ['Item.dpvLifetime', 'Item.nsDpvLifetime'],
    ['Item.latestDPVDate', 'Item.latestNSDPVDate']
  ];
  let metricFields = [];
  metricsOrder.forEach((metricKeysPair, index) => {
    metricFields.push([
      parseField(metricKeysPair[0], schemas),
      parseField(metricKeysPair[1], schemas)
    ]);
  });

  return (
    <div className="content-metrics-table">
      <div className="table-title">
        <div className="field title">DPVs</div>
        <div className="value-overall">
          Overall{' '}
          <TooltipPopover
            pointerPosition="left"
            content={'DPVs from all clients'}
            type="info"
            style={{ width: '160px' }}
          />
        </div>
        <div className="value-nlu">
          Named{' '}
          <TooltipPopover
            pointerPosition="left"
            content={'DPVs from Named License Users'}
            type="info"
            style={{ width: '160px' }}
          />
          License User
        </div>
      </div>
      {metricFields.map((metricPair, index) => {
        let dpvField = metricPair[0];
        let nsDpvField = metricPair[1];
        const formatDisplayValue = metricValue => {
          const fieldValue = data?.props[metricValue?.field];
          if (!fieldValue && fieldValue !== 0) {
            return '--';
          }
          if (metricValue?.schemaField?.dataType == DataType.date) {
            return formatDate(parseDate(fieldValue));
          }
          return fieldValue;
        };
        return (
          <div className="row-container" key={metricPair[0]?.field}>
            <div className="field">
              {dpvField?.schemaField?.name.replace(/ Overall$/, '')}{' '}
              {dpvField?.schemaField?.description && (
                <TooltipPopover
                  pointerPosition="right"
                  content={dpvField?.schemaField?.description}
                  type="info"
                  style={{ width: '160px' }}
                />
              )}
            </div>
            <div className="value-overall">{formatDisplayValue(dpvField)}</div>
            <div className="value-nlu">{formatDisplayValue(nsDpvField)}</div>
          </div>
        );
      })}
    </div>
  );
};

interface SchemaFieldOrderable extends SchemaField {
  order?: number;
}

const COESection = ({ updater }: Pick<ContentMetricsFormProps, 'updater'>) => {
  const data = useSelector(s => s.form?.data);
  const schemas = useSelector(s => s?.planning?.selectedWorkspace?.schemas);
  const itemSchema = getSchema(schemas, NodeType.Item);
  const coeFields: SchemaFieldOrderable[] = itemSchema?.props?.fields?.filter(
    f => f.parentField == 'maintenanceCOE'
  );

  coeFields?.sort((a, b) => a.order - b.order);

  if (!coeFields?.length) return null;

  return (
    <div className="content-metrics-table">
      <div className="table-title">
        <div className="field title">Content Maintenance</div>
      </div>
      <div className="metadata-form">
        {coeFields.map(field => {
          return (
            <Field
              key={field.field}
              field={field}
              data={data}
              schema={itemSchema}
              schemas={schemas}
              updater={updater}
            />
          );
        })}
      </div>
    </div>
  );
};
